import '../main.css'
import '../singles.css'
import { useEffect, } from 'react'
import axios from 'axios'
import { getConfig } from '../config/getConfig'
import { Helmet } from 'react-helmet';

import { FaLocationDot } from "react-icons/fa6";

import hlsLogo from '../images/svg/HLS Logo - White.svg'
import bgImage from '../images/tour_bg.webp'
import peoplePhoto from '../images/tour_band_wide.webp'

const config = getConfig()

const links = [
    {
        enabled: true,
        name: "Germany Tour 2025",
        opening_band: "Throatcut, Skyshape",
        date: "20/11/2025",
        link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-amadeus-tanzspeicher-20395159/",
        venue: "Amadeus",
        city: "Oldenburg",
        country: "Germany",
    },
    {
        enabled: true,
        name: "Germany Tour 2025",
        opening_band: "Interia, Throatcut",
        date: "21/11/2025",
        // link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-spirale-20405761/",
        link: "https://atokbookingevents.ticket.io/k0cu6920/yykm4d/",
        venue: "Spirale",
        city: "Berlin",
        country: "Germany",
    },
    {
        enabled: true,
        name: "Germany Tour 2025",
        opening_band: "TBA",
        date: "22/11/2025",
        // link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-spirale-20405761/",
        link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-club-stereo-20458341",
        venue: "Club Stereo",
        city: "Nuremberg",
        country: "Germany",
    },
    {
        enabled: true,
        name: "Germany Tour 2025",
        opening_band: "Lyink, Your Worst Memory",
        date: "24/11/2025",
        link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-helios37-20395158/",
        venue: "HELIOS37",
        city: "Cologne",
        country: "Germany",
    },
    {
        enabled: true,
        name: "Germany Tour 2025",
        opening_band: "Burning Nations, TBA",
        date: "25/11/2025",
        link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-stadtmitte-karlsruhe-20396561/",
        venue: "Stadtmitte",
        city: "Karlsruhe",
        country: "Germany",
    },
    {
        enabled: true,
        name: "Germany Tour 2025",
        opening_band: "Dark Days, Burning Nations",
        date: "26/11/2025",
        link: "https://www.eventim.de/event/her-last-sight-germany-tour-2025-elfer-club-20395187/",
        venue: "Elferclub",
        city: "Frankfurt Am Main",
        country: "Germany",
    },
]

export default function Tour() {
    const searchParams = new URLSearchParams(window.location.search);
    const paramsObject = {};
    for (let [key, value] of searchParams) { paramsObject[key] = value; }

    async function countVisitors() {
        try {
            axios.get(`${config.backend}/countVisitors?o=${paramsObject.o}&p=tour`)
        } catch (error) { }
    }
    async function sendClick(data, platform = null) {
        const dataCopy = JSON.parse(JSON.stringify(data))
        debugger
        try {
            if (data.type === 'multi') {
                dataCopy.link = data.links[platform]
                delete dataCopy.links
                dataCopy.platform = platform
            }
            const body = { link: dataCopy.link, song_name: `${dataCopy.venue} - ${dataCopy.city} - ${dataCopy.country}`, platform: dataCopy.platform, o: paramsObject.o }
            axios.post(`${config.backend}/click`, body)
        } catch (error) { }
    }

    useEffect(() => {
        countVisitors()
    }, [])

    // return (<div className='bg_full' style={{}}>


    return (
        <>
            <Helmet>
                <title>HLS – Germany Tour 2025</title>
                <meta name="description" content="HLS's are touring germany in 2025 - TICKETS AVAILABLE" />
                <meta property="og:title" content="HLS – Germany Tour 2025" />
                <meta property="og:description" content="HLS's are touring germany in 2025 - TICKETS AVAILABLE" />
                <meta property="og:image" content="https://res.cloudinary.com/dpwavn5n8/image/upload/v1750631380/HLS-TOUR_SQUARE_x6lwto.webp" />
                <meta name="twitter:image" content="https://res.cloudinary.com/dpwavn5n8/image/upload/v1750631380/HLS-TOUR_SQUARE_x6lwto.webp" />
            </Helmet>
            <div className='bg_full_single' style={{ backgroundImage: `url(${bgImage})`, backgroundSize: 'cover', backgroundRepeat: 'no-repeat', backgroundPosition: 'center center', overflowX: 'hidden' }}>
                {/* <div style={{ alignSelf: 'center', }}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', }}>
                        <img src={hlsLogo} style={{ width: "80vw", maxWidth: '800px', height: 'auto' }} alt="" />
                    </div>
                </div> */}
                <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', color: 'white', maxWidth: '1500px', gap: '24px' }}>
                    <img src={peoplePhoto} className='band_photo_tour' alt="band" />
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: '1.5vh', width: '100%', zIndex: '10' }}>
                        {links.map(linkData => buildLink(linkData, sendClick,))}
                    </div>
                    <footer style={{ position: 'fixed', bottom: '0', marginBottom: '2vh', zIndex: '0' }}>
                        Her Last Sight 2026 ©
                    </footer>
                </div>
            </div>
        </>)
}

function buildLink(linkData, sendClick,) {
    const handleClick = (e) => {
        sendClick(linkData);
        window.location = linkData.link
    };
    return (
        <div
            onClick={linkData.enabled ? handleClick : null}
            className="link_box_tour"
            style={{
                position: 'relative', // Added to ensure absolute children are scoped
                boxShadow: '0 4px 24px rgba(0,0,0,0.18)',
                borderRadius: '18px',
                background: 'rgba(255,255,255,0.8)',
                transition: 'transform 0.15s, box-shadow 0.15s',
                cursor: linkData.enabled ? 'pointer' : 'not-allowed',
                padding: '18px 24px',
                marginLeft: 'auto',
                marginRight: 'auto',
                border: linkData.enabled ? '1px solid #e0e0e0' : 'none',
                width: '80%',
            }}
            onMouseOver={e => e.currentTarget.style.transform = 'scale(1.025)'}
            onMouseOut={e => e.currentTarget.style.transform = 'scale(1)'}
        >
            <div style={{ display: 'flex', alignItems: 'center', width: '100%' }} >
                {!linkData.enabled && <div style={{
                    position: 'absolute',
                    zIndex: '1',
                    left: 0,
                    right: 0,
                    top: 0,
                    bottom: 0,
                    width: '100%',
                    height: '100%',
                    background: 'rgba(0,0,0,0.85)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                }}>
                    <span style={{ color: 'red', fontWeight: 'bold', fontSize: '24px', textShadow: '0px 0px 4px black' }}>AVAILABLE SOON!</span>
                </div>}
                <div style={{ display: 'flex', flexDirection: 'column', overflow: 'hidden', gap: '8px', width: '100%' }} className='tour_box_content'>
                    <span style={{ fontWeight: 700, fontSize: '16px', color: linkData.enabled ? '#1a1a1a' : '#444', letterSpacing: '0.5px', textShadow: '0 2px 8px rgba(0,0,0,0.07)', alignItems: 'center', }}>
                        {linkData.name} - {linkData.city}
                    </span>
                    <span style={{ color: 'rgb(100, 100, 100)', fontSize: '12px', fontWeight: '400', }}><b>Support:</b> {linkData.opening_band}</span>

                    <div style={{ display: 'flex', alignItems: 'center', color: '#444', fontSize: '14px' }} >
                        <FaLocationDot style={{ marginRight: '6px', color: '#e63946', fontSize: '1.3em' }} />
                        <span style={{ fontWeight: 500 }}>
                            {linkData.date} - {linkData.venue}, {linkData.city}, {linkData.country}
                        </span>
                    </div>
                </div>
            </div>
        </div>
    )
}